import type { IModuleBaseModel } from "@/3514/types"

enum ECohortModality {
    Group = "group",
    Individual = "individual"
}

interface ICohortAvailableTagModel {
    isFreeResponseAllowed: boolean
    freeResponseValue: string | null
    id: number
    title: string
}

interface ICohortBaseModel {
    id: number
    journeyLength: number
    modality: ECohortModality
    modules: IModuleBaseModel[]
    name: string
}

interface IAttendanceSessionCohortModel extends ICohortBaseModel {
    focusTags: ICohortAvailableTagModel[] | []
}

export { ECohortModality }
export type { ICohortAvailableTagModel, ICohortBaseModel, IAttendanceSessionCohortModel }
